import { Component, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { ReviewPeriod } from '@shared/model';
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'next-review-period-request-dialog',
    templateUrl: './next-review-period-request-dialog.component.html',
    styleUrls: ['./next-review-period-request-dialog.component.scss'],
    standalone: false
})

export class NextReviewPeriodRequestDialogComponent implements OnInit {
  skillControl = new FormControl('', [Validators.required]);
  skills: string[];
  reviewPeriodB: ReviewPeriod;

  constructor(
    private readonly ref: DynamicDialogRef,
    private readonly config: DynamicDialogConfig,
  ) {}

  ngOnInit(): void {
    const { reviewPeriod, skills } = this.config.data;

    this.skills = skills;
    this.reviewPeriodB = reviewPeriod;
  }

  next(): void {
    const data = {
      reviewPeriod: this.reviewPeriodB,
      skill: this.skillControl.value,
    };

    this.ref.close(data);
  }

  cancel(): void {
    this.ref.close();
  }
}
